export default "__VITE_ASSET__BWchWeIO__"